// extracted by mini-css-extract-plugin
module.exports = {"container":"PopconfirmModal_container__1e03o","title":"PopconfirmModal_title__2Wx2c","layout":"PopconfirmModal_layout__2vB_E","flex":"PopconfirmModal_flex__8Qkne"};